import React from 'react';
import { IInvoiceFullObject } from '../../../Interfaces/IInvoice';
import { Chip } from '@mui/material';

interface IProps {
  invoice: IInvoiceFullObject;
}

export const InvoiceStateChip: React.FC<IProps> = ({ invoice }) => {
  return (
    <>
      {invoice.idInvoiceState === 5 ? (
        <Chip variant='outlined' color='success' label='Teilgezahlt' />
      ) : invoice.idInvoiceState === 10 ? (
        <Chip color='success' label='Gezahlt' />
      ) : invoice.idInvoiceState === 15 ? (
        <Chip variant='outlined' color='success' label='Gemahnt' />
      ) : invoice.idInvoiceState === 20 ? (
        <Chip label='Storniert' />
      ) : (
        <Chip label='Offen' />
      )}
    </>
  );
};
